// EDIT: one prefix per app so two apps on one origin do not collide.
const STORAGE_PREFIX = "qtg.help";

/** Per-viewer conveniences only; every access may throw (private mode, blocked storage). */
export function readPreference(key: string): string | null {
  try {
    return window.localStorage.getItem(`${STORAGE_PREFIX}.${key}`);
  } catch {
    return null;
  }
}

export function writePreference(key: string, value: string): void {
  try {
    window.localStorage.setItem(`${STORAGE_PREFIX}.${key}`, value);
  } catch {
    // storage unavailable — the preference simply is not remembered
  }
}
